import React from 'react'
import { Headset, Laptop, Briefcase, Megaphone, ArrowRight, ChartColumn, ChartNoAxesCombined, Handshake } from 'lucide-react'
import TeamIcon from '@/components/icons/TeamIcon'

const CareerPath = () => {
  const handleCardClick = (isHiring: boolean) => {
    if (isHiring) {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLSd2YzY7YuNPNEgTsUIn2yXxz6KIBBsv0GeIDU_8ETw-GM6G1w/viewform?usp=dialog', '_blank')
    }
  }

  const handleApplyNowClick = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSd2YzY7YuNPNEgTsUIn2yXxz6KIBBsv0GeIDU_8ETw-GM6G1w/viewform?usp=dialog', '_blank')
  }

  const careerAreas = [
    {
      icon: Headset ,
      title: "Customer Support (Voice/Non-Voice/Chat/Email)",
      description: "Deliver exceptional support experiences across voice, chat, and email.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: Laptop,
      title: "Technical Support & Helpdesk",
      description: "Solve technical issues and keep systems running smoothly.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: ChartColumn,
      title: "Back-Office & Data Management",
      description: "Manage data, processes, and ensure seamless operations.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: ChartNoAxesCombined,
      title: "Finance & Accounting",
      description: "Drive business growth with accurate finance and accounting.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: Handshake,
      title: "Human Resources & Recruitment",
      description: "Build strong teams through talent acquisition and HR support.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: Megaphone,
      title: "Sales & Telemarketing",
      description: "Boost business growth through impactful sales and outreach.",
      isHiring: true,
      status: 'Currently Hiring'
    },
    {
      icon: TeamIcon,
      title: "Operations & Team Management",
      description: "Lead teams, optimize processes, and deliver operational success.",
      isHiring: true,
      status: 'Currently Hiring'
    }
  ]

  return (
    // <div className="career-page">
      <section className="career-areas section-padding bg-light-blue" id="career-paths">
        <div className="section-container">
          {/* Career Areas Header */}
          <h2 className="section-heading"> Explore Career Paths </h2>
          <p className="subtitle">
            Explore diverse career paths across our organization. Whether you're a seasoned professional or just starting your journey, we have opportunities that match your skills and aspirations.
          </p>
          {/* Career Cards */}
          <div className="career-cards-container">
            {careerAreas.map((area, index) => {
              const IconComponent = area.icon
              const cardClass = area.isHiring ? 'career-card hiring-currently' : 'career-card position-closed'
              return (
                <div 
                  key={index} 
                  className={cardClass}
                  onClick={() => handleCardClick(area.isHiring)}
                  style={{ 
                    cursor: area.isHiring ? 'pointer' : 'default',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div className="career-card-icon">
                    {area.title === "Operations & Team Management" ? (
                      <div style={{ width: '40px', height: '40px', color: '#1874d2' }}>
                        <IconComponent />
                      </div>
                    ) : (
                      <IconComponent size={40} color="#1874d2" />
                    )}
                  </div>
                  <h3 className="career-card-title">{area.title}</h3>
                  <p className="career-card-description">{area.description}</p>
                  <div className="career-card-link status-badge">
                    <span className="status-badge-text">{area.status}</span>
                    <span className="status-badge-icon">
                      <ArrowRight size={16} />
                    </span>
                  </div>
                </div>
              )
            })}
          </div>
           <div className="apply-btn-container">
             <button 
               className="btn apply-btn"
               onClick={handleApplyNowClick}
             >
               Apply Now
             </button>
           </div>
        </div>
      </section>
    // </div>
  )
}

export default CareerPath